module.exports = __webpack_public_path__ + "src/assets/img/afisha.cb309c4d.jpg";